import { render, staticRenderFns } from "./OfficialAccounts.vue?vue&type=template&id=71272773&scoped=true"
import script from "./OfficialAccounts.vue?vue&type=script&lang=js"
export * from "./OfficialAccounts.vue?vue&type=script&lang=js"
import style0 from "./OfficialAccounts.vue?vue&type=style&index=0&id=71272773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71272773",
  null
  
)

export default component.exports